import React from "react";
import { Link } from "react-router-dom";

export default function Logo({ size = "lg", className = "" }) {
  const sizes = {
    sm: "text-2xl",
    md: "text-3xl md:text-4xl",
    lg: "text-6xl md:text-7xl",
  };
  return (
    <Link to="/" className={`inline-flex items-center gap-0 font-display font-semibold tracking-tight ${sizes[size]} ${className}`} style={{ textShadow: "0 1px 12px rgba(255,255,255,0.6)" }}>
      <span style={{ color: "var(--ink)" }}>Bible</span>
      <span className="glow-text" style={{ color: "var(--gold-bright)" }}>Voice</span>
    </Link>
  );
}
